export interface VariableData {
  name: string;
  value: any;
  path: string;
  nodeId: string;
  type: string;
}

export const handleVariableDrop = (
  e: React.DragEvent<HTMLTextAreaElement | HTMLInputElement | HTMLDivElement>,
  currentValue: string,
  onChange: (newValue: string) => void
) => {
  e.preventDefault();
  try {
    const variableData = JSON.parse(e.dataTransfer.getData('application/reactflow/variable')) as VariableData;
    if (variableData && variableData.value !== undefined) {
      const target = e.target as HTMLTextAreaElement | HTMLInputElement;
      const start = target.selectionStart ?? currentValue.length;
      const end = target.selectionEnd ?? currentValue.length;


      // Insert the ACTUAL VALUE instead of the variable syntax
      const valueToInsert = String(variableData.path);
      const newValue = currentValue.substring(0, start) + valueToInsert + currentValue.substring(end);
      onChange(newValue);

      // Set cursor position after the inserted value
      setTimeout(() => {
        const newPosition = start + valueToInsert.length;
        target.selectionStart = newPosition;
        target.selectionEnd = newPosition;
        target.focus();
      }, 0);
    }
  } catch (error) {
    console.error('Error handling variable drop:', error);
  }
};

export const handleDragOver = (e: React.DragEvent) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = 'copy';
};

// Utility to check if drag contains variable data
export const isVariableDrag = (e: React.DragEvent): boolean => {
  return e.dataTransfer.types.includes('application/reactflow/variable');
};

// Optional: Add visual feedback during drag operations
export const handleDragEnter = (e: React.DragEvent) => {
  if (isVariableDrag(e)) {
    e.currentTarget.classList.add('drag-over');
  }
};

export const handleDragLeave = (e: React.DragEvent) => {
  e.currentTarget.classList.remove('drag-over');
};